import { Link } from "react-router-dom";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ContinueComponent from "../../toastAlerts/ContinueComponent";

//icons
import { PencilSquare } from "react-bootstrap-icons";
import { BsTrash } from "react-icons/bs";

const FlightsItem = ({
    id,
    item,
    handleDeleteFlights
}) => {
    const { t } = useTranslation();
    //show contnue
    const [showContinue, setShowContinue] = useState(false);

    return (
        <div className="w-full flex-col flex py-2 bg-white dark:bg-slate-700 p-2 rounded-lg justify-between">
            <div className="w-full flex flex-col">
                <div className="flex flex-col gap-1">
                    <p className="text-gray-400 text-[12px]">{t("admin_flight_number")}:</p>
                    <p className="text-gray-500 text-[12px]">{item.code}</p>
                </div>
                <div className="flex flex-col gap-1">
                    <p className="text-gray-400 text-[12px]">{t("admin_approx_arrival")}:</p>
                    <p className="text-gray-500 text-[12px]">{item.estemated_date}</p>
                </div>
                <div className="flex flex-col gap-1">
                    <p className="text-gray-400 text-[12px]">{t("admin_arrival_time")}:</p>
                    <p className="text-gray-500 text-[12px]">{item.arrival_date}</p>
                </div>
                <div className="flex flex-col gap-1">
                    <p className="text-gray-400 text-[12px]">{t("admin_country")}:</p>
                    <p className="text-gray-500 text-[12px]">
                        {item.country_id === 4 && t("admin_turkey")}
                        {item.country_id === 3 && t("admin_china")}
                    </p>
                </div>
                <div className="flex flex-col gap-1">
                    <p className="text-gray-400 text-[12px]">{t("admin_flight_type")}:</p>
                    <p className="text-gray-500 text-[12px]">
                        {item.type === 1 && t("admin_cargo")}
                        {item.type === 2 && t("admin_airplane")}
                        {item.type === 3 && t("admin_ship")}
                    </p>
                </div>
                <div className="flex flex-col gap-1">
                    <p className="text-gray-400 text-[12px]">{t("admin_status")}:</p>
                    <p className="text-gray-500 text-[12px]">
                        {item.status === 1 && t("admin_not_started")}
                        {item.status === 2 && t("admin_on_the_way")}
                        {item.status === 3 && t("admin_has_arrived")}
                    </p>
                </div>
                <div className="flex flex-col gap-1">
                    <p className="text-gray-400 text-[12px]">{t("admin_description")}:</p>
                    <p className="text-gray-500 text-[12px]">{item.description}</p>
                </div>
            </div>

            <div className="w-full flex gap-1 mt-2">
                <Link to={`../flights/${id}`} className="w-full rounded-lg bg-violet-400
                 flex gap-2 items-center justify-center p-1 py-3">
                    <PencilSquare className="text-white font-bold" />
                    <p className="text-white text-sm font-bold">{t("admin_edit")}</p>
                </Link>
                <div
                    onClick={() => { setShowContinue(true) }}
                    className="w-12 rounded-lg bg-red-400
                                flex gap-2 items-center justify-center p-3 cursor-pointer">
                    <BsTrash className="text-white font-bold w-full h-full" />
                </div>
            </div>
            <ContinueComponent
                showFlag={showContinue}
                actionFunction={handleDeleteFlights}
                setShowContinue={setShowContinue}
                id={id}
            />
        </div>
    )
}

export default FlightsItem;
